<template>
  <div
    class="lp-child-base"
    :class="hideAddvertise ? `lp-child-base--validCpno` : 'lp-child-base--invalidCpno'"
    :style="styles"
  >
    <div class="lp-child-base__hero">
      <block-hero :target-info="targetInfo" :color-scheme="colorScheme"/>
      <block-fortune-input
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :action="action"
        :method="method"
        :token="token"
        :lp-id="lpId"
        pageLabel="basicinput"
        :event-label="1"
      >
        <div class="label">本格開運占い<ruby>「属性開抛<span>ぞくせいかいほう</span>」</ruby>を体験</div>
      </block-fortune-input>
    </div>

    

    <!-- <block-about-counselor :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId"/> -->
    <block-about-fortune2 :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-member :gadata-info="gadataInfo" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-points :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-other-contents :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>
    <block-special :ga-target="gaTarget" :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :subsc-url="subscUrl"/>

    <!-- <block-about-fortune :target-info="targetInfo" :color-scheme="colorScheme" :lp-id="lpId" :banner-type="bannerType"/> -->
    <!-- <block-review :target-info="targetInfo" :color-scheme="colorScheme" :review-list="reviewListMod" :lp-id="lpId"/> -->
    <!-- <div class="block-deluxe-banner">
      <img src="/static/img/toppage/lp/hokatotoAll2.png" alt="本格＆豪華占い" @click="onDeluxeBannerClick">
    </div> -->

    <template v-if="!hideAddvertise">
       <!-- <block-menus
        v-if="menusList && menusList.length"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :menu-list="menusList"
        :tab-list="menusTabList"
        :lp-id="lpId"
        :subscr-enable="+salesInvalid > 0"
        :subsc-url="subscUrl"
      />  -->
      <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->
      <!-- <block-banner
        class="block-banner--middle"
        v-if="showBanner"
        banner-pos="middle"
        :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
        :lp-id="lpId"
        :campaign="bannerType"
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :has-caption="true"
      /> -->
      <!-- <block-uranai-tv
        :target-info="targetInfo"
        :color-scheme="colorScheme"
        :subsc-url="subscUrl"
        :lp-id="lpId"
        :is-individualed="true"
        :emphasis-color="'#c9454d'"
      /> -->
    </template>
    
    <!-- <block-banner
      v-if="showBanner"
      banner-pos="bottom"
      :ga-event-categ="`LP${this.lpId}-LINE-campaign-banner`"
      :lp-id="lpId"
      :campaign="bannerType"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
    /> -->
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockReview from '@/utvStore/components/recommend/lp/blocks/BlockReview'
import BlockMenus from './blocks/BlockMenus'
import BlockMember from './blocks/BlockMember'
import BlockOtherContents from './blocks/BlockOtherContents'
import BlockSpecial from './blocks/BlockSpecial'
import BlockPoints from './blocks/BlockPoints'
import BlockUranaiTv from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTv'
import BlockHero from './blocks/BlockHero'
import BlockAboutCounselor from './blocks/BlockAboutCounselor'
import BlockAboutFortune from './blocks/BlockAboutFortune'
import BlockAboutFortune2 from './blocks/BlockAboutFortune2'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockFortuneInput from './blocks/BlockFortuneInput'

export default {
  name: 'LpMain',
  components: {
    LpBaseButton,
    BlockHero,
    BlockAboutCounselor,
    BlockAboutFortune,
    BlockAboutFortune2,
    BlockReview,
    BlockMenus,
    BlockMember,
    BlockOtherContents,
    BlockSpecial,
    BlockPoints,
    BlockUranaiTv,
    BlockBanner,
    LineCampaignMessage,
    BlockFortuneInput,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    reviewList: {
      type: Array,
      default(){
        return []
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    hideAddvertise: {
      type: Boolean,
      default: false,
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    salesInvalid: {
      type: Number,
      default: 0,
    },
    subscUrl: String,
    token: {
      type: String,
      default: '',
    },
    gadataInfo: {
      type: String,
      default: 'gaData',
    },
    gaTarget: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post'
    }
  },
  computed:{
    reviewListMod() {
      console.log('targetInfo:%O', this.targetInfo)
      return !!this.reviewList && this.reviewList.length > 0 ? this.reviewList : (!!this.targetInfo.reviews ? this.targetInfo.reviews : [])
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    showBanner() {
      return true
    },
  },
  methods: {
    onDeluxeBannerClick(){
      window.gtag('event', 'click', {
        'event_category': 'LP3-deluxe-menu',
        'event_label': '10001'
      })
      location.href = this.$handoverParams('/deluxe/lp/1')
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  &--validCpno {
    .block-review-base {
      padding-bottom: 0;
    }
  }
  &--invalidCpno {}
  .block-menu-base {
    background: #F9F5ED;
  }
  &__hero {
    position: relative;
    max-width: 580px;
    margin: auto;
    .block-fortune-input {
      position: absolute;
      bottom: 4.4554%;
      left: 5.333%;
      right: 5.333%;
      width: auto;
      background: none;
      padding: 0;
      /deep/ {
        .content-wrap {
          background: rgba(#fff, 0.9);
          padding: 40px 32px;
        }
        .form-label { display: none;}
        .formGroup .calenderForm.formControl {
          width: 100% !important;
          background: #fff;
          justify-content: center;
          max-width: 260px;
          margin: auto;
          overflow: hidden;
          > * {
            flex: 0 1 0;
            font-size: 14px;
            outline: none;
            margin: 0;
          }
        }
        .submit-btn {
          margin-top: 24px !important;
          width: auto !important;
          max-width: 326px;
        }
        .baseButton__button {
          min-width: auto;
        }
      }
    }
    .label {
      font-weight: bold;
      font-size: 18px;
      line-height: 21px;
      text-align: center;
      margin: 0 0 20px;
      ruby {
        position: relative;
        margin: 0 -5px;
        > span {
          position: absolute;
          top: -18px;
          left: 0;
          right: 0;
          text-align: center;
          font-size: 0.55em;
        }
      }
    }
  }
  .block-deluxe-banner {
    width: 100%;
    padding: 40px 20px 0;
    background: white;
    max-width: 580px;
    margin: auto;
    img {
      display: block;
      width: 100%;
      cursor: pointer;
      user-select: none;
    }
  }
  .block-uranaitv-base {
    background: #F2F2F2;
    padding-top: 36px;
  }
  .block-banner--middle {
    background: #FBF8F1;
    padding: 8px 20px 60px;
  }
  /deep/ {
    .block-uranaitv-base__menu {
      background: #F9F5ED;
    }
    .block-uranaitv-base__menu-head {
      background: #9C8961;
    }
    .block-uranaitv-base__benefit {
      background: #F2F2F2;
    }
    .block-uranaitv-base__point-point svg {
      fill: #9C8961;
    }
    .block-uranaitv-base__copy b {
      color: #C9454D;
    }
  }
 }
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/LpMain.vue